import type {
  ChannelRecord,
  CreateChannelRequest,
  CreateChannelResponse,
  DeleteChannelResponse,
  ListChannelsResponse,
  UpdateChannelRequest,
  UpdateChannelResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listChannels(
  fetchImpl: typeof fetch = fetch,
): Promise<ListChannelsResponse> {
  return opsApiRequest<ListChannelsResponse>('/v1/ops/channels', { method: 'GET' }, fetchImpl);
}

export function createChannel(
  body: CreateChannelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateChannelResponse> {
  return opsApiRequest<CreateChannelResponse>('/v1/ops/channels', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function updateChannel(
  id: string,
  body: UpdateChannelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateChannelResponse> {
  return opsApiRequest<UpdateChannelResponse>(`/v1/ops/channels/${id}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function deleteChannel(
  id: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteChannelResponse> {
  return opsApiRequest<DeleteChannelResponse>(`/v1/ops/channels/${id}`, {
    method: 'DELETE',
  }, fetchImpl);
}
